module.exports = __webpack_public_path__ + "img/danielle_hernandez.35cdf805.png";